const state = {
  step: 0,
  date: {},
  time: '',
  timeOptions: {},
  appointmentId: null,
};

const getters = {
  getScheduleStep: (state) => state.step,
  getScheduleDate: (state) => state.date,
  getScheduleTime: (state) => state.time,
  getScheduleTimeOptions: (state) => state.timeOptions,
  getAppointmentId: (state) => state.appointmentId,
};

const mutations = {
  CHANGE_SCHEDULE_STEP(state, payload) {
    state.step = payload;
  },
  CHANGE_SCHEDULE_DATE(state, payload) {
    state.date = payload;
  },
  CHANGE_SCHEDULE_TIME(state, payload) {
    state.time = payload;
  },
  CHANGE_SCHEDULE_TIME_OPTIONS(state, payload) {
    state.timeOptions = payload;
  },
  APPOINTMENT_ID(state, payload) {
    state.appointmentId = payload;
  },
};

export default {
  state,
  getters,
  mutations,
};



// WEBPACK FOOTER //
// ./resources/js/store/modules/schedule-flow.js